// extracted by mini-css-extract-plugin
export default {"webcam":"WebcamCapture_webcam__Rej8-","close":"WebcamCapture_close__zsFR8","button":"WebcamCapture_button__Ia0+N"};